import {
  VERIFICA_BOASVINDAS_SUCCESS,
  INSERE_BOASVINDAS_SUCCESS,
  RESET_BOASVINDAS,
} from './constants';

/* eslint-disable default-param-last */
const initialState = {
  Exibir: false,
  EtapaAtual: 0,
  Erro: '',
};

export default function tourBoasVindas(state = initialState, action) {
  switch (action.type) {
    case VERIFICA_BOASVINDAS_SUCCESS:
      return {
        ...state,
        ...action.values,
      };
    case INSERE_BOASVINDAS_SUCCESS:
      return {
        ...state,
        ...action.values,
      };
    case 'VERIFICA_BOASVINDAS_ERROR':
      return {
        ...state,
        ...action.values,
      };
    case 'INSERE_BOASVINDAS_ERROR':
      return {
        ...state,
        ...action.values,
      };
    case RESET_BOASVINDAS:
      return initialState;
    default:
      return state;
  }
}
